import { Row, StandardPanel, StandardPanelParams } from "./standard.panel";

export interface StandardPanelViewParams extends StandardPanelParams {
    items: Array<{
        label: string;
        value: string | number | null | undefined;
        visible?: boolean;
    }>
}

export function StandardViewPanel(params: StandardPanelViewParams) {
    return (
        <StandardPanel {...params} >
            {
                params.items
                    .filter(row => row.visible !== false)
                    .map((row, index) => (
                    <Row key={index} label={row.label} value={row.value} />
                ))
            }
        </StandardPanel >
    )
}
